module.exports = __webpack_public_path__ + "img/quicktips37.d46523f0.svg";